<div class="overlay" [@blurFadeInOut]="isClosing ? 'fadeOut' : 'fadeIn'" (@blurFadeInOut.done)="onAnimationDone()">
    <div class="modal" [@fadeInOut]="isClosing ? 'fadeOut' : 'fadeIn'" (@fadeInOut.done)="onAnimationDone()"
        appClickedOutside (clickedOutside)="closeModal()">
        <div class="header">
            <div class="call-name">{{callTitle}}</div>
            <div class="cross-icon" (click)="closeModal()">
                <img src="assets/icons/x-close.svg" [alt]="'assignment.CLOSE_BUTTON' | transloco"/>
            </div>
        </div>
        <div class="tabs-row">
          <div class="tabs-row-inner">
            <div class="tabs">
            <button type="button" *ngFor="let tab of visibleTabs" class="tab-btn" [ngClass]="{'active': tab === activeTab}"
                (click)="setActiveTab(tab)">
                {{ translateTab$(tab) | async }}
            </button>
          </div>
          <button qai-button [kind]="'primary'" [size]="'medium'" class="launch-call"
                *ngIf="!shouldHideLaunchButton"
                [disabled]="shouldDisableLaunchButton"
                (click)="navigateToStartCall(moduleAssignmentUuid, callUuid, practiceType, callType)"
                [matTooltip]="isMaxAttemptsReached ? 'You have reached the maximum number of attempts' : ''"
                matTooltipClass="tooltip-dark">
                {{'assignment.LAUNCH_CALL' | transloco}}
                <qai-icon kind="arrow-up-right" positionEnd />
            </button>
          </div>
        </div>
        
        <div class="details">
            <div class="tab-content" *ngIf="activeTab">
                <div class="tabText">
                    <p [innerHTML]="processedMarkdown"></p>
                </div>
            </div>
        </div>
    </div>
</div>